<template>
  <div class="p-3">
    <div id="pop-up" v-if="loading == true">
      <div class="">
        <b-spinner
          variant="primary"
          style="width: 4rem; height: 4rem"
          label=""
        ></b-spinner>
      </div>
    </div>
    <div class="createQuestion">
      <div class="">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <p class="pr-2 text-nowrap">
              {{ $t("group_topic_list.label.category") }}:
            </p>
            <multiselect
              v-model="cateSelected"
              :close-on-select="true"
              :clear-on-select="false"
              label="category"
              :multiple="true"
              :options="category"
              :placeholder="$t('group_topic_list.label.select_and_select_one')"
              track-by="category"
              :hide-selected="true"
              :max-height="150"
              class=""
              @select="checkCategoryPermission"
            >
            </multiselect>
          </div>

          <div class="d-flex align-items-center">
            <div class="d-flex align-items-center my-4 px-3">
              <p class="pr-2">{{ $t("question_list.label.type") }}:</p>
              <b-form-select
                v-model="form.type"
                :options="typeOfQuestions"
              ></b-form-select>
            </div>
            <div class="d-flex align-items-center my-4 px-3">
              <p class="pr-2">{{ $t("question_list.label.difficulty") }}:</p>
              <b-form-select
                v-model="form.difficulty"
                :options="difficultyOption"
              ></b-form-select>
            </div>
          </div>
        </div>
        <div class="row justify-content-around">
          <div class="col left-embed p-0">
            <!-- //embed video/image -->
            <div
              class="d-flex flex-column align-items-center embed-image-video"
              style="height:100%;"
            >
              <ion-icon
                style="font-size: 60px; margin-bottom: 10px"
                name="cloud-upload-outline"
                v-if="!form.image_path && !form.video_path && !embedPath "
              >
              </ion-icon>
              <label
                v-if="!form.image_path  && !form.video_path && !embedPath"
                class="label-uploadImage"
                for="uploadImageEditTopic"
                style="white-space: nowrap"
              >
                {{ $t("group_topic_list.label.select_file") }}
              </label>
              <input
                v-if="
                  !imageUpload &&
                    !form.image_path &&
                    !embedPath &&
                    !form.video_path
                "
                type="file"
                @change="handleFileUpload"
                class=""
                id="uploadImageEditTopic"
              />
              <div
                v-if="
                  video_s3 ||
                    imageUpload ||
                    embedPath ||
                    form.image_path ||
                    form.video_path  ||
                    file
                "
                id="preview"
                class=""
              >
                <img v-if="imageUpload" :src="imageUpload" />
                <iframe :src="embedPath"
                        class="iframe"
                        v-if="embedPath.includes('youtube')"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
	              <img :src="embedPath"
	                      class="iframe"
	                      v-if="embedPath.includes('youtube') === false && embedPath"
	                      />
                <video
                  style="width: 500px;"
                  v-if="
                    form.video_path &&
                      !imageUpload &&
                      !embedPath &&
                      video_s3
                  "
                  controls
                  :src="video_s3"
                  id="video-preview"
                ></video>
                <video
                  style="width: 500px; height: 100%"
                  v-if="file && !video_s3 && !imageUpload && !embedPath"
                  :src="file"
                  controls
                  id="video-preview"
                ></video>
                <button @click="removeFile">X</button>
              </div>
              <div id="embedUpload"></div>
              <div
                class="d-flex justify-content-between embed-image my-2"
                v-if="!form.image_path  && !form.video_path"
              >
                <input
                  v-model="form.embed_image_video"
                  maxlength="500"
                  type="text"
                  v-if="!embedPath"
                />
                <button @click="embed()"  v-if="!embedPath">
                  {{ $t("question_list.label.embed_image") }}
                </button>
              </div>
            </div>
          </div>
          <div class="col">
            <div
              v-if="!embedAudio"
              class="d-flex align-items-center justify-content-between mb-4"
            >
              <div class="upload-audio">
                <button
                  class="upload-audio-button"
                  for="upload-audio-input"
                  type="button"
                >
                  <b-icon
                    icon="music-note-beamed"
                    font-scale="1.5"
                    style="margin-right: 5px"
                    variant="danger"
                  ></b-icon>
                  <label style="white-space: nowrap" for="upload-audio-input">{{
                      $t("question_list.label.audio")
                  }}</label>
                </button>
                <b-form-file
                  accept="audio/*"
                  @change="handleAudioUpload($event)"
                  class="pr-1"
                  id="upload-audio-input"
                ></b-form-file>
              </div>
              <audio
                :src="getAudioPath"
                id="audio-preview"
                controls
                v-show="getAudioPath"
              />
              <audio
                v-show="audioUpload"
                id="form"
                :src="audioUpload"
                controls
              />
              <ion-icon
                @click="removeAudio"
                v-show="audioUpload || getAudioPath"
                name="close-circle-outline"
                style="font-size: 40px"
              ></ion-icon>
            </div>
            <div v-if="!embedAudio">
	            <div
			            v-if="!form.audio_path && !audioUpload"
			            class="embed-audio d-flex flex-row"
	            >
		            <b-button @click="audioEmbedLeft">
			            <b-icon
					            icon="box-arrow-up"
					            font-scale="1.2"
					            variant="success"
			            ></b-icon>
			            <span>{{ $t("question_list.label.embed_video_audio") }}</span>
		            </b-button>
		            <input
				            :placeholder="
                  $t('question_list.label.embed_video_audio_placeHolder')
                "
				            v-model="form.embed_audio"
				            maxlength="500"
				            type="text"
				            id="embed_audio_link"
		            />
	            </div>
            </div>
						<div>
							<ion-icon
									class="remove-embed-audio-btn-topic-edit"
									@click="removeEmbedAudio"
									v-if="embedAudio"
									name="close-circle-outline"
							></ion-icon>
							<div id="audio_embed_view" v-html="embedAudio">
								{{ embedAudio }}
							</div>
						</div>
            <div class="question-input__textArena">
              <textarea
                v-model="form.title"
                @keyup="charCount()"
                name=""
                id=""
                class=""
                rows="3"
                maxlength="1500"
                placeholder="Typing for question..."
              ></textarea>
              <!-- <span>{{ this.form.title.length }} / 1500</span> -->
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3 float-right">
        <b-button @click="hideEdit" variant="danger">{{
          $t("group_topic_list.button.cancel")
        }}</b-button>
        <b-button
          @click="EditTopics()"
          style="margin-left: 1rem"
          variant="primary"
          >{{ $t("group_topic_list.button.save") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  props: ["rowTopicItem"],
  components: { Multiselect },
  data() {
    return {
      loading: false,
      isText: null,
      imageReRender: 0,
      cateSelected: [],
      defaultNumberAnswer: 4,
      typeOfQuestions: [
        { text: "Listening", value: 0 },
        { text: "Writing", value: 1 },
        { text: "Reading", value: 2 },
          { text: "Speaking", value: 3 }
      ],
      alphabetAnswerSelected: 0,
      typeOfAnswers: [
        { text: "Alphabet", value: 0 },
        { text: "Number", value: 1 }
      ],
      statusSelected: 1,
      difficultyOption: [],
      imageUpload: "",
      embedUpload: "",
      audioUpload: "",
      // getImageUpload :null,
      getAudioPath: "",
      embedAudio: "",
      embedPath: "",
      answerUpload: [],
      correctAnswer: [],
      file: "",
      fillterData: {
        search: "",
        page: 1,
        selected: {
          id: "",
          group_topic: "",
          teacher: "",
          category: "",
          difficulty: "",
          typeTopic: "",
          status: "",
          paginate: 20
        }
      },
      form: {
        id: "",
        title: "",
        type: 1,
        status: "Active",
        score: "",
        difficulty: "",
        category: [],
        explain: "explain",
        image_path: "",
        video_path: "",
        embed_image_video: "",
        audio_path: "",
        embed_audio: "",
        answer_option: "One choice",
        answer: [],
        image: [],
        answer_text: [],
        number_answer: 4
      },
      video_s3: "",
      selectedTypeAnswer: "Alphabet",
      tags: []
    };
  },
  computed: {
    ...mapState("config", ["category", "difficulty"]),
    ...mapState("auth", ["user"]),
    ...mapGetters({
      getTopicListRes: "topics/topicListRes",
      getTopicOneItemRes: "topics/topicOneItemRes",
      editTopicRes: "topics/editTopicRes"
    }),
    
    categoryIdsAllow() {
      return this.user?.category_ids_apply || "";
    }
  },

  methods: {
      audioEmbedLeft() {
      if(!this.form.embed_audio){
        this.$bvToast.toast(this.$t(`msg["E_UC2.2_43"]`), {
          title: this.$t("difficulty.notice"),
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }
      if (
        this.form.embed_audio.includes("<iframe") &&
        this.form.embed_audio.includes("></iframe>") &&
        this.form.embed_audio.includes("src=")
      ) {
        this.embedAudio = this.form.embed_audio;
        document.getElementById("audio_embed_view").innerHTML = this.embedAudio;
      } else {
        this.$bvToast.toast(this.$t("questions_create.message.data_invalid"), {
          title: this.$t("difficulty.notice"),
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }
    },
    async EditTopics() {
      this.loading = true;
      let data = new FormData();

      for (let i = 0; i < this.cateSelected.length; i++) {
        this.form.category[i] = this.cateSelected[i]["category"];
      }

      if (this.cateSelected.length == 0) {
        this.$root.toast(
          this.$t(`msg["E_UC2.2_18"]`),
          "danger",
          this.$t(`msg["E_UC2.1_23"]`)
        );
      this.loading = false;
        return;
      }
      if (!this.form.title) {
        this.$root.toast(
          this.$t(`msg["E_UC2.2_18"]`),
          "danger",
          this.$t(`msg["E_UC2.2_06"]`)
        );
      this.loading = false;
        return;
      }

      //   Type Topic
      if (this.form.type == 0) {
        this.form.type = "Listening";
      } else if (this.form.type == 1) {
        this.form.type = "Writing";
      } else if (this.form.type == 2) {
        this.form.type = "Reading";
      } else if (this.form.type == 3) {
          this.form.type = "Speaking";
      }

      this.form.image.map(photo => data.append("image[]", photo, photo.name));
      data.append("id", this.form.id);
      data.append("type", this.form.type);
      data.append("title", this.form.title);
      data.append(
        "category",
        JSON.stringify(this.form.category).replace(/\\(.)/gm, "$1")
      );
      data.append("difficulty", this.form.difficulty);
      data.append("image_path", this.form.image_path);
      data.append("video_path", this.form.video_path);
      data.append("audio_path", this.form.audio_path);
      data.append("embed_audio", this.form.embed_audio);
      data.append("embed_path", this.form.embed_image_video);



      this.$root.$loading.start();
      await this.$store.dispatch("topics/editTopic", [data, this.rowTopicItem]);
      this.$root.$loading.finish();
      if (this.$store.state.topics.editTopicRes.status === 200) {
        await this.$store.dispatch("topics/getTopicTest", this.fillterData);
        for (let i = 0; i < this.getTopicListRes.length; i++) {
          let getTime = this.getTopicListRes[i].updated_at;
          let getDay = new Date(getTime).getUTCDate();
          let getMonth = new Date(getTime).getUTCMonth() + 1;
          let getYear = new Date(getTime).getUTCFullYear();
          this.getTopicListRes[i].updated_at =
            getDay + "/" + getMonth + "/" + getYear;
        }
        this.$bvModal.hide("modal-edit");
        this.$root.toast(
          this.$t("group_topic_list.button.update"),
          "success",
          this.$t("group_topic_list.alert.update_success")
        );
      this.loading = false;
      } else {
        const apiRes = this.$store.state.topics.editTopicRes;
        const errors =
          apiRes?.errors?.title ||
         { message: apiRes?.message } || "";
        const errorFields = Object.values(errors);

        this.$root.toast(
          this.$t('msg["E_UC2.2_18"]'),
          "danger",
          this.$t(`msg["${errorFields}"]`)
        );
        this.disable = true;
        this.loading = false;
      }
    },
    hideEdit() {
      this.$bvModal.hide("modal-edit");
    },
    charCount: function() {
      this.form.title.length = this.form.title.length;
    },
    handleImageUpload(e) {
      const img = e.target.files[0];
      this.form.image_path = img;
      this.imageUpload = URL.createObjectURL(img);
    },
    handleAnswerUpload(e, index) {
      const img = e.target.files[0];
      this.form.image.push(img);
      // this.form.image[index] = img;
      this.answerUpload[index] = URL.createObjectURL(img);
      this.imageReRender += 1;
    },
    previewAudio() {
      let audio = document.getElementById("audio-preview");
      let reader = new FileReader();

      reader.readAsDataURL(this.file);
      reader.addEventListener("load", function() {
        audio.src = reader.result;
      });
    },
    handleAudioUpload(event) {
      if (event.target.files[0].size / 1048576 > 10) {
          this.$bvToast.toast(this.$t(`msg["E_UC2.2_16"]`), {
            title: this.$t("difficulty.notice"),
            autoHideDelay: 5000,
            variant: "danger"
          });
        return;
        }
      this.audioUpload = event.target.files[0];
      this.form.audio_path = this.audioUpload;
      this.audioUpload = URL.createObjectURL(this.audioUpload);
    },
    handleFileUpload(e) {
      // check validate
      let fileUpload = e.target.files[0].name.split(".");
      let typeOfFile = fileUpload[fileUpload.length - 1];

      if (
        typeOfFile === "mp4" ||
        typeOfFile === "jpg" ||
        typeOfFile === "jpeg" ||
        typeOfFile === "png"
      ) {
        if (e.target.files[0].size / 1048576 > 10) {
          this.$bvToast.toast(this.$t(`msg["E_UC2.2_16"]`), {
            title: this.$t("difficulty.notice"),
            autoHideDelay: 5000,
            variant: "danger"
          });
        } else if (typeOfFile === "mp4") {
          this.file = e.target.files[0];
          this.form.video_path = this.file;
          this.file = URL.createObjectURL(this.file);
        } else {
          const img = e.target.files[0];
          this.form.image_path = img;
          this.imageUpload = URL.createObjectURL(img);
        }
      } else {
        this.$bvToast.toast("File upload invalid form data", {
          title: this.$t("difficulty.notice"),
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }
    },
    embed() {
        if(!this.form.embed_image_video){
        this.$bvToast.toast(this.$t(`msg["E_UC2.2_43"]`), {
          title: this.$t("difficulty.notice"),
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }
      if (
        this.form.embed_image_video.includes("https://") ||
        this.form.embed_image_video.includes("http://") ||
        this.form.embed_image_video.includes("<iframe")
      ) {
        this.embedPath = this.form.embed_image_video;
        document.getElementById("embedPath").innerHTML =
        '<embed width="500" height="250" src="' +
        this.embedPath +
        '"  frameborder="0"   allowfullscreen></embed>';
      } else {
        this.$bvToast.toast(this.$t(`msg["E_UC2.2_13"]`), {
          title: this.$t("difficulty.notice"),
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }
    },
    removeFile: function() {
      this.imageUpload = "";
      this.embedPath = "";
      this.file = "";
      this.form.image_path = "";
      this.video_s3 = "";
      this.form.video_path = "";

    },
    removeImage: function() {
      this.imageUpload = "";
      this.form.image_path = "";
    },
    removeAudio: function() {
      this.getAudioPath = "";
      this.file = "";
      this.form.audio_path = "";
      this.audioUpload = "";
      let audio = document.getElementById("audio-preview");
      audio.src = "";
    },
    removeEmbedAudio: function() {
      this.form.embed_audio = "";
      this.embedAudio = "";
      document.getElementById("embed_audio_link").value = "";
      document.getElementById("audio_embed_view").innerHTML = "";
    },
    removeAnswerImage: function(index) {
      this.answerUpload[index] = "";
      this.imageReRender += 1;
    },
    // the loai cau hoi
    backToListQuestion() {
      this.$root.$loading.start();
      this.$router.push({ name: "QuestionList" });
      this.$root.$loading.finish();
    },
    checkCategoryPermission(item) {

      // Không phải tài khoản giáo viên B2B thì không cần check quyền category
      const businessId = Number(this.user?.business_id || 0);
      if (businessId <= 0) {
          return;
      }
      // ENd check tài khoản giáo viên
      const allowedIds = this.categoryIdsAllow
        .split(",")
        .map(id => String(id).trim())
        .filter(Boolean);

      const categoryId = String(item.id);

      if (!allowedIds.includes(categoryId)) {
        this.$nextTick(() => {
          this.cateSelected = this.cateSelected.filter(
            cate => String(cate.id) !== categoryId
          );
        });

        this.$root.toast(
          this.$t(`msg["title_notification"]`),
          "danger",
          this.$t(`msg["content_noti_topic"]`),
        );
      }
    }
  },
  async created() {
     await this.$root.$loading.start();
    await this.$store.dispatch("config/getCategory");

    // get Difficulty
    let getDifficultyTopic = {
      value: "",
      text: ""
    };
    for (let j = 0; j < this.difficulty.length; j++) {
      getDifficultyTopic = {
        value: this.difficulty[j].difficulty,
        text: this.difficulty[j].difficulty
      };
      this.difficultyOption.push(getDifficultyTopic);
    }
    await this.$store.dispatch("topics/getOneTopicTest", this.rowTopicItem);
    this.form.type = this.getTopicOneItemRes.type;
    this.form.image_path = this.getTopicOneItemRes.image_path ?
                        this.getTopicOneItemRes.image_path : "";
    this.form.title = this.getTopicOneItemRes.title;
    // this.file = this.getTopicOneItemRes.audio_path;
    this.typeSelected = this.getTopicOneItemRes.type;
    this.form.difficulty = this.getTopicOneItemRes.difficulty;
    this.form.category = this.getTopicOneItemRes.category;
    this.form.embed_image_video = this.getTopicOneItemRes.embed_path ?
                        this.getTopicOneItemRes.embed_path : "";
    this.form.video_path = this.getTopicOneItemRes.video_path ?
                        this.getTopicOneItemRes.video_path : "";
    this.form.audio_path = this.getTopicOneItemRes.audio_path ?
                        this.getTopicOneItemRes.audio_path : "";
    this.form.embed_audio = this.getTopicOneItemRes.embed_audio ?
                        this.getTopicOneItemRes.embed_audio : "";
    this.getAudioPath = this.getTopicOneItemRes.audio_s3 ?
                        this.getTopicOneItemRes.audio_s3 : "";
    this.embedPath = this.getTopicOneItemRes.embed_path ?
                        this.getTopicOneItemRes.embed_path : "";
    this.embedAudio = this.getTopicOneItemRes.embed_audio ?
                        this.getTopicOneItemRes.embed_audio : "";
    this.video_s3 = this.getTopicOneItemRes.video_s3 ?
                        this.getTopicOneItemRes.video_s3 : "";

    if (this.getTopicOneItemRes.type == "Listening") {
      this.form.type = 0;
    } else if (this.getTopicOneItemRes.type == "Writing") {
      this.form.type = 1;
    } else if (this.getTopicOneItemRes.type == "Reading") {
      this.form.type = 2;
    } else if (this.getTopicOneItemRes.type == "Speaking") {
        this.form.type = 3;
    }
    //

    // get category
    for (let j = 0; j < this.getTopicOneItemRes.category.length; j++) {
      const reqData = { category: this.getTopicOneItemRes.category[j] };
      this.cateSelected.push(reqData);
    }

    // get image-path
    if (this.getTopicOneItemRes.image_path !== "") {
      this.imageUpload = this.getTopicOneItemRes.image_s3;
    }



    this.$root.$loading.finish();
  }
};
</script>

<style>
@import "../../assets/scss/Questions.scss";

* {
  font-size: 15px;
}

.label-uploadImage {
  background: #0ae8cd;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  cursor: pointer;
  padding: 16px 91px;
}

#uploadImageEditTopic {
  display: none;
}

.left-embed {
}

.embed-image {
  width: 63%;
}

.embed-image button {
  width: 100%;
}

.embed-image-video {
  height: 100%;
  justify-content: center;
  margin-right: 10px;
}

.embed-image input {
  padding: 10px 10px;
  background: #e5eaff;
  border-radius: 10px;
  border: none;
}

.embed-image button {
  background: #0ae8cd;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  border: none;
  margin-left: 10px;
}

#preview {
  height: 250px;
  width: 500px;
  position: relative;
}

#preview img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

#preview button {
  position: absolute;
  right: -10px;
  z-index: 1;
  top: -10px;
  border-radius: 50px;
  width: 30px;
}

.upload-audio {
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.upload-audio-button label {
	margin-bottom: 0px;
	padding: 10px 0px;
}

.upload-audio .upload-audio-button {
  display: flex;
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
  border-radius: 2px;
  border: none;
  font-size: 15px;
  align-items: center;
  position: relative;
	justify-content: center;
}

.upload-audio #upload-audio-input__BV_file_outer_ {
  display: none;
}

.upload-audio #upload-audio-input,
.upload-audio .custom-file-label {
  display: none;
}

#audio-preview {
  padding: 10px;
  width: 100%;
  align-items: center;
}
#form {
  padding: 10px;
  width: 100%;
  align-items: center;
}

.embed-audio {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.embed-audio button {
  width: 27%;
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
  border-radius: 2px;
  border: none;
  color: black;
}

.embed-audio input {
  width: 72%;
  background: #e5eaff;
  border-radius: 3px;
  border: none;
  padding: 5px 10px;
}

.answer-options {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
}

.answer-options p {
  width: 27%;
  margin-right: 6px;
}

.answer-options select {
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
  border-radius: 2px;
  border: none;
  padding: 8px 18px;
}

.question-input__textArena {
  position: relative;
}

.question-input__textArena textarea {
  width: 100%;
  background: #e5eaff;
  border-radius: 10px;
  border: none;
  padding: 20px;
  font-size: 15px;
}

.question-input__textArena span {
  position: absolute;
  width: max-content;
  bottom: 10px;
  right: 10px;
  font-size: 15px;
}

.btn-explanation {
  background: #ffbf00;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
  border-radius: 2px;
  border: none;
  padding: 11px 33px;
}

.checked,
.checkboxInvisible {
  position: absolute;
  right: 0%;
  top: 0%;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  z-index: 999;
}

.answerQuestion {
  position: relative;
  border: 1px solid black;
  width: 49%;
  border: 1px solid #c4c4c4;
  border-radius: 8px;
  padding: 10px;
  height: fit-content;
}

.answerQuestion div button {
  border: none;
  padding: 10px;
  border-radius: 10px;
  margin-left: 20px;
}

textarea {
  border: none;
  outline: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  overflow-y: auto;
  resize: none; /*remove the resize handle on the bottom right*/
}

.option-question {
  display: flex;
  justify-content: space-between;
  text-align: center;
  align-items: center;
}

.tesst1 {
  display: flex;
}

.answerQuestion img {
  max-height: 100px;
  width: 50%;
  -o-object-fit: contain;
  object-fit: contain;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.header-edit-topic {
  width: 75%;

}
.remove-embed-audio-btn-topic-edit{
    font-size: 30px;
    position: absolute;
    top: -15px;
    right: -5px;
    z-index: 999;
    color: black;
    border-radius: 30px;
    background-color: white;
}

.iframe {
  height: 250px !important;
}
</style>
